module.exports = __webpack_public_path__ + "static/media/17UN-Women7.2f69a74b.jpg";